/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useEffect, useState, ReactNode } from 'react';

export type Lang = 'pt' | 'en';

// ─── Dicionário ───────────────────────────────────────────────────────────────
export const translations = {
  pt: {
    // Nav
    nav_dashboard:   'Visão Consolidada',
    nav_events:      'Projetos',
    nav_institute:   'Institute',
    nav_somatoria:   'Somatória',
    nav_timeline:    'Agenda de Projetos',
    nav_audit:       'Log de Alterações',
    nav_manage:      'Gestão de Eventos',
    nav_users:       'Usuários',
    nav_fx_rates:    'Taxas de Câmbio',
    nav_budgets:      'Budgets Institute',
    // Geral
    loading:         'Carregando...',
    save:            'Salvar',
    cancel:          'Cancelar',
    delete_confirm_title: 'Excluir item',
    delete_confirm_body:  'Tem certeza que deseja excluir este item? Esta ação não pode ser desfeita.',
    delete_confirm_yes:   'Excluir',
    edit:            'Editar',
    delete:          'Excluir',
    search:          'Buscar',
    filter:          'Filtrar',
    all:             'Todos',
    no_data:         'Nenhum dado encontrado.',
    confirm:         'Confirmar',
    close:           'Fechar',
    error_loading:   'Erro ao carregar dados',
    // Dashboard
    dash_title:      'Visão Consolidada',
    dash_subtitle:   'Controle orçamentário por divisão',
    dash_budget:     'Budget Total',
    dash_forecast:   'Previsão',
    dash_contracted: 'Contratado',
    dash_realized:   'Realizado',
    dash_delta:      'Delta',
    dash_s1:         '1º Semestre',
    dash_s2:         '2º Semestre',
    dash_within:     'Dentro do orçamento',
    dash_over:       'Fora do orçamento',
    dash_proj_budget:     'Orçamento dos Projetos',
    dash_inst_budget:     'Orçamento do Instituto',
    dash_total_orc:       'Orçamento Total',
    dash_view_general:    'Visão Geral',
    dash_breakdown:       'Breakdown por Projeto',
    dash_total_geral:     'TOTAL GERAL',
    dash_division:        'Divisão',
    dash_events_col:      'Eventos',
    dash_s1_orc:          'S1 Orç.',
    dash_s2_orc:          'S2 Orç.',
    dash_pct_cont:        '% Cont.',
    dash_event_name:      'Evento',
    dash_event_tipo:      'Tipo',
    dash_event_data:      'Data',
    dash_event_sem:       'Sem.',
    dash_budget_aprovado: 'Budget Aprovado',
    dash_pct_uso:         '% Uso',
    dash_access_pending:  'Acesso pendente de atribuição',
    dash_access_msg:      'Sua conta foi criada com sucesso. As demais funcionalidades ficarão disponíveis assim que um administrador atribuir um perfil à sua conta.',
    dash_eventos_total:   'Total Orçado:',
    dash_events_subtitle: 'eventos · £ GBP',
    // Projetos / Eventos
    events_title:    'Projetos',
    events_subtitle: 'Controle de custos por evento',
    events_budget:   'Budget Aprovado',
    events_forecast: 'Previsão',
    events_contracted: 'Realizado OPS',
    events_realized: 'Realizado',
    events_delta:    'Delta Real vs Real. OPS',
    events_within:   'DENTRO DO BUDGET',
    events_over:     'FORA DO BUDGET',
    events_all_div:  'Todas as divisões',
    events_all_sem:  'Todos os semestres',
    events_s1:       '1º Semestre',
    events_s2:       '2º Semestre',
    events_note:     'Observações gerais',
    events_note_ph:  'Adicione observações sobre este evento...',
    events_all:      'Todas',
    events_year:     'Ano todo',
    events_saving:   '💾 Salvando...',
    events_none:     'Nenhum evento encontrado para o filtro selecionado.',
    events_search:      'Buscar evento por nome…',
    events_search_none: 'Nenhum evento encontrado para',
    events_search_count: 'resultado(s) para',
    events_code:     'Código',
    events_account:  'Conta',
    events_preview:  'Previsão',
    events_realized_fin: 'Realizado Fin.',
    events_pct_cont: '% Real. OPS/Orçado',
    events_delta_real: 'Delta Real vs Real. OPS',
    events_total:    'TOTAL',
    events_costs:    '💰 Custos',
    events_contract_deadline: 'Contrato',
    events_payment_deadline:  'Quitação',
    events_over_budget: '⚠ Acima do budget',
    events_cancelled:   'CANCELADO',
    events_add_item:    '+ Adicionar item',
    events_no_items:    'Nenhum item adicionado ainda. Clique em "+ Adicionar item" para começar.',
    events_description_ph: 'Descrição do gasto...',
    events_add_confirm: '✓ Adicionar',
    events_vencido:  'VENCIDO',
    events_a_vencer: 'A VENCER',
    events_item_contracted: 'Realizado OPS:',
    events_item_realized:   'Realizado:',
    events_showing:  'Exibindo',
    events_of:       'de',
    events_word:     'eventos',
    event_word:      'evento',
    events_in_month: 'evento em',
    events_in_month_plural: 'eventos em',
    events_s1_count: 'eventos no 1º Semestre',
    events_s2_count: 'eventos no 2º Semestre',
    events_year_count: 'eventos no ano',
    events_autosave: 'salva automaticamente',
    item_op_label: 'Qual operação?',
    item_late_notice_pre: 'Este lançamento será descontado diretamente do instituto da divisão',
    item_op_forecast: 'Previsão',
    item_op_ops: 'Realizado Ops',
    item_op_fin: 'Realizado Fin',
    item_currency_label: 'Qual moeda?',
    item_desc_label: 'Descrição',
    item_desc_ph: 'Descreva o gasto...',
    item_value_label: 'Valor',
    item_motivo_label: 'Motivo da Previsão',
    item_motivo_ph: 'Descreva a lógica por trás desta previsão...',
    item_motivo_required: 'Campo obrigatório para itens de Previsão',
    item_motivo_ops_label: 'Motivo do Realizado',
    item_motivo_ops_ph: 'Descreva o motivo deste valor realizado...',
    item_desc_ph_forecast: 'Descreva a previsão de gasto...',
    item_desc_ph_ops:      'Descreva o gasto contratado / realizado pela operação...',
    item_desc_ph_fin:      'Descreva o gasto financeiro confirmado...',
    item_value_label_forecast: 'Valor previsto',
    item_value_label_ops:      'Valor contratado',
    item_value_label_fin:      'Valor realizado',
    item_desc_required: 'Descrição é obrigatória',
    kpi_orcado: 'Orçado',
    rfvo_title:     'Realizado Fin. × Orçado',
    rfvo_of_budget: 'do orçado',
    rfvo_balance:   'Saldo',
    rfvo_no_budget: 'Orçado não definido',
    kpi_orcado_gbp: 'Orçado £',
    kpi_contratado: 'Previsão',
    kpi_contratado_gbp: 'Previsão £',
    kpi_real_ops: 'Real. Ops',
    kpi_real_fin: 'Real. Fin',
    kpi_delta: 'Δ Ops vs Fin',
    kpi_status: 'Status',
    // Month names (short)
    month_jan: 'Jan', month_feb: 'Fev', month_mar: 'Mar', month_apr: 'Abr',
    month_may: 'Mai', month_jun: 'Jun', month_jul: 'Jul', month_aug: 'Ago',
    month_sep: 'Set', month_oct: 'Out', month_nov: 'Nov', month_dec: 'Dez',
    // Month names (full)
    month_january: 'Janeiro', month_february: 'Fevereiro', month_march: 'Março',
    month_april: 'Abril', month_may_full: 'Maio', month_june: 'Junho',
    month_july: 'Julho', month_august: 'Agosto', month_september: 'Setembro',
    month_october: 'Outubro', month_november: 'Novembro', month_december: 'Dezembro',
    // Institute
    inst_title:      'Institute',
    inst_subtitle:   'Controle orçamentário por divisão · Orçado e Contratado · salva ao sair do campo',
    inst_budget:     'Budget Instituto',
    inst_total_forecast: 'Total Orçado',
    inst_total_contracted: 'Total Contratado',
    inst_s1_forecast:    '1º Sem. Orçado',
    inst_s2_forecast:    '2º Sem. Orçado',
    inst_s1_contracted:  '1º Sem. Contratado',
    inst_s2_contracted:  '2º Sem. Contratado',
    inst_delta:          'Delta (Orç − Cont)',
    inst_saving:         '💾 Salvando...',
    inst_rubrica:        'Rubrica',
    inst_total_anual:    'Total Anual',
    inst_orc_cont:       'Orçado / Contratado',
    inst_orc:            'Orçado',
    inst_cont:           'Contratado',
    inst_row_rt:           'Roundtable',
    inst_row_viagCliente:  'Viagens Comerciais (Clientes)',
    inst_row_viagStaff:    'Viagens Comerciais (Staff)',
    inst_row_instGeral:    'Instituto Geral',
    inst_disc_title:       'Descontos de projetos (lançamentos tardios)',
    inst_disc_subtitle:    'Projetos de anos anteriores cujos custos foram lançados após o fechamento do ano e descontados deste instituto.',
    inst_disc_total:       'Total descontado',
    inst_disc_late:        'lançado após o fechamento',
    inst_disc_launches:    'lançamentos',
    inst_launches:         'Lançamentos',
    inst_launch_trace:     'outro ano',
    inst_budget_available: 'Disponível após lançamentos',
    tour_start: 'Como usar',
    tour_skip: 'Pular',
    tour_prev: 'Anterior',
    tour_next: 'Próximo',
    tour_done: 'Concluir',
    tour_inst_intro_title: 'Tela do Instituto',
    tour_inst_intro_body: 'Um tour rápido pelos principais pontos desta tela. Use Próximo/Anterior ou as setas do teclado; Esc fecha.',
    tour_inst_div_title: 'Escolha a divisão',
    tour_inst_div_body: 'Selecione aqui a divisão cujo instituto você quer ver ou editar. Operações vê só a sua; Finance e Admin, todas.',
    tour_inst_year_title: 'Ano vigente',
    tour_inst_year_body: 'Troque o ano por aqui. Os valores, o budget e os lançamentos mudam conforme o ano selecionado.',
    tour_inst_kpis_title: 'Indicadores',
    tour_inst_kpis_body: 'Resumo da divisão:',
    tour_inst_kpis_b1: 'Budget disponível — já líquido dos lançamentos',
    tour_inst_kpis_b2: 'Orçado e Contratado anuais',
    tour_inst_kpis_b3: 'Delta = orçado − contratado + lançamentos',
    tour_inst_kpis_b4: 'Total de lançamentos do ano',
    tour_inst_grid_title: 'Edição mês a mês',
    tour_inst_grid_body: 'Edite cada mês/rubrica:',
    tour_inst_grid_b1: 'Clique no campo e digite — salva automaticamente',
    tour_inst_grid_b2: 'Tecle "-" para valores negativos',
    tour_inst_grid_c_amber: 'Âmbar: valor negativo',
    tour_inst_grid_c_red: 'Vermelho: contratado acima do orçado',
    tour_inst_grid_c_green: 'Verde: contratado dentro do orçado',
    tour_inst_launch_title: 'Lançamentos tardios',
    tour_inst_launch_body: 'Custos de eventos de anos encerrados caem aqui (Institute Geral).',
    tour_inst_launch_b1: 'Clique para abrir o modal com a lista completa',
    tour_inst_launch_b2: 'Reduzem o budget disponível e o delta do ano vigente',
    tour_inst_launch_b3: 'No ano de referência aparecem só para rastreabilidade',
    tour_inst_done_title: 'Pronto!',
    tour_inst_done_body: 'Você pode reabrir este tour quando quiser pelo botão "Como usar" no menu.',
    // Somatória
    soma_subtitle:   'Projetos + Institute por divisão · £ GBP',
    soma_budget:     'Budget Aprovado',
    soma_plan:       'Planejamento Ops',
    soma_delta:      'Delta',
    soma_extra:      'Budget Extra (50%)',
    soma_v1:         'Planej. V1',
    soma_evts:       'Evts',
    soma_plan_col:   'Planej.',
    soma_extra_col:  'Extra 50%',
    soma_v1_col:     'V1',
    soma_total_plan: 'Total · Planejamento',
    // FX Rates
    fx_title:             'Taxas de Câmbio',
    fx_subtitle:          'Taxas de conversão para GBP (£) utilizadas em todo o sistema.',
    fx_subtitle_canedit:  'Clique em uma taxa para editar.',
    fx_base:              'Moeda base do sistema',
    fx_base_card_label:   'Moeda base do sistema',
    fx_updated:           'Atualizado em',
    fx_click_edit:        'Clique para editar',
    fx_loading:           'Carregando taxas...',
    fx_status_title:      'Status',
    fx_status:            'Status',
    fx_active_currencies: 'Moedas ativas',
    fx_base_currency:     'Moeda base',
    fx_last_update:       'Última atualização',
    fx_how_title:         'Como funciona',
    fx_how_it_works:      'Como as taxas funcionam',
    fx_how_body1:         'Cada taxa indica quantas unidades da moeda equivalem a £ 1.',
    fx_how_body2:         'Exemplo: USD ≈ 1,36 → £ 1.000 = US$ 1.360.',
    fx_how_body3:         'A alteração é imediata nos relatórios, mas não altera valores já gravados.',
    fx_equiv_title:       'Equivalente a £ 1.000',
    fx_equivalent_panel:  'Equivalente a £ 1.000',
    fx_note:              'Como as taxas funcionam: todos os valores lançados em moedas diferentes de GBP são convertidos automaticamente.',
    fx_confirm_title:     'Confirmar alteração de taxa',
    fx_confirm_note_bold: 'Atenção:',
    fx_confirm_note:      'esta taxa será usada imediatamente em todos os dashboards, relatórios e cálculos de conversão. Os valores já registrados no banco',
    fx_modal_changing:    'Você está alterando a taxa de',
    fx_modal_note:        'Esta taxa será usada imediatamente em todos os dashboards, relatórios e cálculos de conversão. Os valores já registrados no banco',
    fx_modal_note_bold:   'não serão alterados',
    fx_modal_note_suffix: '— apenas a conversão para GBP será recalculada.',
    fx_confirm_cancel:    'Cancelar',
    fx_confirm_save:      'Confirmar alteração',
    logout_title:         'Sair',
    logout_body:          'Você será desconectado da sua conta GRI Institute. Deseja continuar?',
    logout_cancel:        'Cancelar',
    logout_confirm:       'Sair',
    settings_title:      'Preferências',
    settings_language:   'Idioma',
    users_no_division:        'Sem divisão',
    users_confirm_block_title:   'Bloquear usuário',
    users_confirm_block_body:    'Este usuário será bloqueado e não conseguirá mais acessar o sistema.',
    users_confirm_block_btn:     'Bloquear',
    users_confirm_unblock_title: 'Reativar usuário',
    users_confirm_unblock_body:  'Este usuário voltará a ter acesso ao sistema com perfil Viewer.',
    users_confirm_unblock_btn:   'Reativar',
    app_title: 'Planejamento e Controle de Custos',
    theme_to_light: 'Tema claro',
    theme_to_dark: 'Tema escuro',
    // KPI hints
    kpi_hint_proj_budget:     'Budget aprovado dos eventos',
    kpi_hint_inst_budget:     'Budget destinado ao Institute',
    kpi_hint_inst_budget_missing: 'Não configurado para este ano',
    kpi_configure: 'Configurar',
    dash_how_title: 'Como ler este painel',
    dash_how_1: 'Budget (Orç.): valor aprovado para o evento ou Institute.',
    dash_how_2: 'Contratado: soma dos cost lines já contratados, convertidos para GBP.',
    dash_how_3: 'Delta: Budget − Contratado. Negativo = acima do orçamento.',
    dash_how_4: 'ForecastV1: projeção ajustada considerando extrapolação do semestre.',
    events_how_title: 'Como funcionam os Projetos',
    events_how_1: 'Cada evento possui linhas de custo (accounts) e itens dentro de cada linha.',
    events_how_2: 'Budget Aprovado: valor de referência definido pelo Finance.',
    events_how_3: 'Contrato Inicial: confirma que o planejamento foi revisado.',
    events_how_4: 'Contrato Final: aprovação pós-evento. Trava edições no evento.',
    inst_how_title: 'Como funciona o Institute',
    inst_how_1: 'Rubricas: Roundtable (viagens internas), Viagem c/ Cliente, Viagem c/ Staff, Inst. Geral.',
    inst_how_2: 'Orçado: valor planejado para o mês. Contratado: valor já comprometido.',
    inst_how_3: 'S1 = Jan–Jun, S2 = Jul–Dez. Totais calculados automaticamente.',
    inst_how_4: 'O budget anual da divisão é configurado em Administração → Institute Budgets.',
    budgets_how_title: 'Como configurar budgets',
    budgets_how_1: 'Defina o budget Institute anual por divisão para cada ano futuro.',
    budgets_how_2: 'Anos passados são travados e não podem ser editados.',
    budgets_how_3: 'O valor aqui impacta os KPIs de todas as telas do sistema.',
    audit_how_title: 'Sobre o Log de Alterações',
    audit_how_1: 'Registra todas as criações, edições e exclusões feitas por usuários.',
    audit_how_2: 'Expanda cada linha para ver o diff campo a campo (antes → depois).',
    audit_how_3: 'Apenas administradores têm acesso a esta tela.',
    kpi_hint_total_orc:       'Projetos + Institute',
    kpi_hint_contracted:      'Total contratado até agora',
    kpi_hint_within:          '✓ Dentro do budget',
    kpi_hint_over:            '⚠ Acima do budget',
    kpi_hint_inst_budget_div: 'Budget aprovado da divisão',
    kpi_hint_forecast_sum:    'Soma anual do orçado',
    kpi_hint_contracted_sum:  'Soma anual do contratado',
    kpi_hint_launches_sum:    'Lançamentos pós-fechamento',
    toggle_contract_initial:     'Contrato inicial fechado',
    toggle_contract_final:       'Contrato final aprovado por Ops',
    toggle_final_date_required:  'disponível após a data do evento',
    toggle_final_locked:         'Evento bloqueado — aprovação irreversível',
    toggle_final_confirm_title:  'Confirmar aprovação final',
    toggle_final_confirm_body:   'Ao confirmar, o evento e seus itens ficarão bloqueados permanentemente para edição. Esta ação não pode ser revertida. Tem certeza?',
    toggle_final_confirm_btn:    'Confirmar',
    toggle_final_reopen:          'Reabrir',
    kpi_hint_s1:              'Jan–Jun',
    kpi_hint_s2:              'Jul–Dez',
    kpi_hint_soma_budget:     'Projetos + Institute',
    kpi_hint_soma_plan:       'Time Operações — forecast total',
    kpi_hint_soma_delta:      'Acima do budget',
    kpi_hint_soma_extra:      'Aprovado: delta / 2',
    kpi_hint_soma_v1:         'Budget + Extra aprovado',
    // Status badges
    status_ok:   'OK',
    status_over: 'OVER',
    status_over_budget: 'OVER BUDGET',
    fx_btn_save_inline:   'Salvar',
    fx_saving:            'Salvando...',
    fx_saved:             '✓ Salvo',
    fx_unit_value:        '1 unidade da moeda',
    fx_gbp_value:         'vale em GBP (£)',
    fx_example:           'Exemplo',
    fx_immediate:         'imediata',
    fx_no_change_saved:   'não altera valores já gravados',
    // Usuários
    users_title:     'Usuários',
    users_role:      'Perfil',
    users_division:  'Divisão',
    users_save:      'Salvar',
    users_subtitle:      'Gerencie roles e divisões de acesso',
    users_you:           'você',
    users_saved:         '✓ Salvo',
    users_saving:        'Salvando…',
    users_role_viewer:   'Viewer',
    users_role_viewer_desc: 'Só leitura',
    users_role_ops:      'Ops Manager',
    users_role_ops_desc: 'Edita custos da sua divisão',
    users_role_finance:  'Finance',
    users_role_finance_desc: 'Edita tudo',
    users_role_admin:    'Admin',
    users_role_admin_desc: 'Acesso total + usuários',
    // Audit
    audit_title:     'Log de Alterações',
    audit_subtitle:  'Histórico de todas as edições — quem fez, o quê, quando',
    audit_all:       'Todos',
    audit_cost_lines: 'Linhas de Custo',
    audit_cost_items: 'Itens de Custo',
    audit_events:    'Eventos',
    audit_fx:        'Taxas de Câmbio',
    audit_changed_fields: 'Campos alterados',
    audit_no_changes: 'Nenhuma alteração de valor detectada.',
    audit_prev:      '← Anterior',
    audit_next:      'Próxima →',
    audit_records:   'registros',
    audit_record:    'registro',
    audit_page_of:   'página',
    audit_of:        'de',
    audit_action_create: 'Criado',
    audit_action_update: 'Editado',
    audit_action_delete: 'Removido',
    audit_table_cost_line:      'Linha de Custo',
    audit_table_cost_line_item: 'Item de Custo',
    audit_table_institute:      'Institute',
    audit_table_event:          'Evento',
    audit_table_fx_rate:        'Taxa de Câmbio',
    audit_table_user:           'Usuário',
    audit_table_division_budgets: 'Budget Divisão',
    audit_more_fields:  '+{n} mais',
    audit_insert_values: 'Valores incluídos',
    audit_delete_values: 'Valores removidos',
    audit_filter_user:  'Usuário',
    audit_filter_all_users: 'Todos os usuários',
    audit_filter_from:  'De',
    audit_filter_to:    'Até',
    // Timeline
    timeline_title:      'Agenda de Projetos',
    timeline_subtitle:   'Clique em um mês para ver os eventos, contratos e quitações',
    timeline_all:        'Todas',
    timeline_events_in:  '🎯 Eventos em',
    timeline_contracts:  '📋 Contratos a fechar este mês',
    timeline_settlements:'💳 Quitações previstas (+15 dias úteis)',
    timeline_no_activity:'Nenhuma atividade em',
    timeline_collision:  '⚠️ COLISÃO',
    timeline_status_late:'Atrasado',
    timeline_status_this_month: 'Este mês',
    timeline_status_todo:'A fazer',
    timeline_status_expected:'Previsto',
    timeline_budget:     'Budget:',
    timeline_contracted_pct: 'cont.',
    timeline_event_status_final:   '🔒 Contrato Final',
    timeline_event_status_initial: '📋 Contrato Inicial',
    timeline_event_status_pending: '⏳ Sem contrato',
    timeline_event_in:   'Evento em',
    timeline_events_count: 'eventos',
    timeline_contracts_count: 'contratos',
    timeline_settlements_count: 'quitações',
    // Manage Events
    manage_title:        'Gestão de Eventos',
    manage_subtitle:     'eventos · criar, editar e excluir',
    manage_new_event:    '+ Novo evento',
    manage_search:       '🔍 Buscar evento...',
    manage_all_divisions:'Todas as divisões',
    manage_no_events:    'Nenhum evento cadastrado ainda.',
    manage_no_filter:    'Nenhum evento encontrado com esses filtros.',
    manage_form_name:    'Nome do evento',
    manage_form_name_ph: 'Ex: GRI São Paulo Summit 2026',
    manage_form_division:'Divisão',
    manage_form_type:    'Tipo',
    manage_form_date:    'Data',
    manage_form_budget:  'Budget aprovado',
    manage_form_sf_id:   'ID Salesforce (opcional)',
    manage_form_sf_ph:   'Ex: a0B5e000003XXXX',
    manage_form_note:    'Nota geral (opcional)',
    manage_form_note_ph: 'Observações...',
    manage_edit_event:   '✏️ Editar Evento',
    manage_edit_budget:  'Editar Budget',
    manage_new_event_title: '+ Novo Evento',
    manage_saving:       'Salvando...',
    manage_save_changes: 'Salvar alterações',
    manage_create_event: 'Criar evento',
    manage_delete_title: 'Excluir evento?',
    manage_delete_msg:   'e todos os seus custos serão removidos permanentemente.',
    manage_deleting:     'Excluindo...',
    manage_contracted:   'contratado',
    manage_sf_label:     'SF:',
    manage_event_count:  'evento',
    manage_events_count: 'eventos',
    // Sync status
    sync_status_label:   'Salesforce',
    sync_status_ok:      'Em dia',
    sync_status_errors:  'Último sync com erros',
    sync_status_outdated:'Desatualizado',
    sync_status_waiting: 'Aguardando primeiro sync (06:00 BRT)',
    sync_last_update:    'última atualização em',
    sync_at:             'às',
    sync_auto:           'Automático · 06:00 BRT',
    sync_events_updated: 'eventos atualizados',
    sync_of_received:    'de',
    sync_received_sf:    'recebidos do SF',
    sync_errors:         'erro(s)',
    // Nomes de moeda
    currency_name_GBP: 'Libra Esterlina',
    currency_name_EUR: 'Euro',
    currency_name_USD: 'Dólar Americano',
    currency_name_BRL: 'Real Brasileiro',
    currency_name_INR: 'Rúpia Indiana',
    currency_name_JPY: 'Iene Japonês',
    currency_name_CAD: 'Dólar Canadense',
    currency_name_AUD: 'Dólar Australiano',
    currency_name_CHF: 'Franco Suíço',
    currency_name_CNY: 'Yuan Chinês',
    currency_GBP:    'Libra Esterlina',
    currency_EUR:    'Euro',
    currency_USD:    'Dólar Americano',
    currency_BRL:    'Real Brasileiro',
    currency_INR:    'Rúpia Indiana',
    currency_AED:    'Dirham dos Emirados',
    currency_JPY:    'Iene Japonês',
    currency_CAD:    'Dólar Canadense',
    currency_AUD:    'Dólar Australiano',
    currency_CHF:    'Franco Suíço',
    currency_CNY:    'Yuan Chinês',
    // BudgetsPage
    budgets_title:              'Budget Institute por Ano',
    budgets_subtitle:           'Orçamento do Institute por divisão · Valores em £ GBP · Anos passados bloqueados automaticamente',
    budgets_division:           'Divisão',
    budgets_confirm_title:      'Confirmar alteração de budget',
    budgets_current:            'Atual:',
    budgets_new:                'Novo:',
    budgets_confirming:         'Salvando...',
    budgets_confirm_btn:        'Confirmar',
    // FX modais extras
    fx_currency_in_use:         'Moeda em uso',
    fx_currency_in_use_msg:     'está sendo usada por',
    fx_currency_in_use_events:  'evento(s)',
    fx_delete_currency:         'Excluir moeda',
    fx_delete_confirm_msg:      'e todos os seus custos serão removidos permanentemente. Esta ação não pode ser desfeita.',
    fx_deleting:                'Excluindo...',
    fx_new_currency:            'Nova Moeda',
    fx_new_currency_btn:        '+ Nova Moeda',
    fx_cancel_form:             '✕ Cancelar',
    // UsersPage extras
    users_access_global:        'Acesso global',
    users_admin_global:         'Admin tem acesso global a todas as divisões.',
    users_email_label:          'Email *',
    users_name_label:           'Nome (opcional)',
    users_role_label:           'Perfil',
    users_divisions_label:      'Divisões *',
    users_adding:               'Adicionando...',
    users_add_btn:              'Adicionar Usuário',
    users_block_btn:            'Bloquear',
    users_unblock_btn:          'Reativar',
    users_remove_btn:           'Remover',
    users_remove_confirm:       'Remover este usuário da allowlist?',
  },
  en: {
    // Nav
    nav_dashboard:   'Consolidated View',
    nav_events:      'Projects',
    nav_institute:   'Institute',
    nav_somatoria:   'Summary',
    nav_timeline:    'Project Schedule',
    nav_audit:       'Change Log',
    nav_manage:      'Event Management',
    nav_users:       'Users',
    nav_fx_rates:    'Exchange Rates',
    nav_budgets:      'Institute Budgets',
    // Geral
    loading:         'Loading...',
    save:            'Save',
    cancel:          'Cancel',
    delete_confirm_title: 'Delete item',
    delete_confirm_body:  'Are you sure you want to delete this item? This action cannot be undone.',
    delete_confirm_yes:   'Delete',
    edit:            'Edit',
    delete:          'Delete',
    search:          'Search',
    filter:          'Filter',
    all:             'All',
    no_data:         'No data found.',
    confirm:         'Confirm',
    close:           'Close',
    error_loading:   'Error loading data',
    // Dashboard
    dash_title:      'Consolidated View',
    dash_subtitle:   'Budget control by division',
    dash_budget:     'Total Budget',
    dash_forecast:   'Forecast',
    dash_contracted: 'Contracted',
    dash_realized:   'Realized',
    dash_delta:      'Delta',
    dash_s1:         '1st Semester',
    dash_s2:         '2nd Semester',
    dash_within:     'Within budget',
    dash_over:       'Over budget',
    dash_proj_budget:     'Project Budget',
    dash_inst_budget:     'Institute Budget',
    dash_total_orc:       'Total Budget',
    dash_view_general:    'Overview',
    dash_breakdown:       'Project Breakdown',
    dash_total_geral:     'GRAND TOTAL',
    dash_division:        'Division',
    dash_events_col:      'Events',
    dash_s1_orc:          'H1 Budget',
    dash_s2_orc:          'H2 Budget',
    dash_pct_cont:        '% Contr.',
    dash_event_name:      'Event',
    dash_event_tipo:      'Type',
    dash_event_data:      'Date',
    dash_event_sem:       'Sem.',
    dash_budget_aprovado: 'Approved Budget',
    dash_pct_uso:         '% Usage',
    dash_access_pending:  'Access pending assignment',
    dash_access_msg:      'Your account was successfully created. Other features will be available once an administrator assigns a role to your account.',
    dash_eventos_total:   'Total Budget:',
    dash_events_subtitle: 'events · £ GBP',
    // Projetos / Eventos
    events_title:    'Projects',
    events_subtitle: 'Cost control by event',
    events_budget:   'Approved Budget',
    events_forecast: 'Forecast',
    events_contracted: 'Realized OPS',
    events_realized: 'Realized',
    events_delta:    'Realized vs Real. OPS Delta',
    events_within:   'WITHIN BUDGET',
    events_over:     'OVER BUDGET',
    events_all_div:  'All divisions',
    events_all_sem:  'All semesters',
    events_s1:       '1st Semester',
    events_s2:       '2nd Semester',
    events_note:     'General notes',
    events_note_ph:  'Add notes about this event...',
    events_all:      'All',
    events_search:      'Search event by name…',
    events_search_none: 'No events found for',
    events_search_count: 'result(s) for',
    events_year:     'Full year',
    events_saving:   '💾 Saving...',
    events_none:     'No events found for the selected filter.',
    events_code:     'Code',
    events_account:  'Account',
    events_preview:  'Forecast',
    events_realized_fin: 'Fin. Realized',
    events_pct_cont: '% Real. OPS/Budgeted',
    events_delta_real: 'Realized vs Real. OPS Delta',
    events_total:    'TOTAL',
    events_costs:    '💰 Costs',
    events_contract_deadline: 'Contract',
    events_payment_deadline:  'Settlement',
    events_over_budget: '⚠ Over budget',
    events_cancelled:   'CANCELLED',
    events_add_item:    '+ Add item',
    events_no_items:    'No items added yet. Click "+ Add item" to get started.',
    events_description_ph: 'Expense description...',
    events_add_confirm: '✓ Add',
    events_vencido:  'OVERDUE',
    events_a_vencer: 'DUE SOON',
    events_item_contracted: 'Realized OPS:',
    events_item_realized:   'Realized:',
    events_showing:  'Showing',
    events_of:       'of',
    events_word:     'events',
    event_word:      'event',
    events_in_month: 'event in',
    events_in_month_plural: 'events in',
    events_s1_count: 'events in 1st Semester',
    events_s2_count: 'events in 2nd Semester',
    events_year_count: 'events in year',
    events_autosave: 'auto-saves',
    item_op_label: 'Which operation?',
    item_late_notice_pre: 'This launch is discounted directly from the institute of division',
    item_op_forecast: 'Forecast',
    item_op_ops: 'Realized Ops',
    item_op_fin: 'Realized Fin',
    item_currency_label: 'Which currency?',
    item_desc_label: 'Description',
    item_desc_ph: 'Describe the expense...',
    item_value_label: 'Value',
    item_motivo_label: 'Forecast Reason',
    item_motivo_ph: 'Describe the logic behind this forecast...',
    item_motivo_required: 'Required for Forecast items',
    item_motivo_ops_label: 'Actual Reason',
    item_motivo_ops_ph: 'Describe the reason for this actual value...',
    item_desc_ph_forecast: 'Describe the forecast expense...',
    item_desc_ph_ops:      'Describe the contracted / ops-realized expense...',
    item_desc_ph_fin:      'Describe the financially confirmed expense...',
    item_value_label_forecast: 'Forecast amount',
    item_value_label_ops:      'Contracted amount',
    item_value_label_fin:      'Realized amount',
    item_desc_required: 'Description is required',
    kpi_orcado: 'Budgeted',
    kpi_orcado_gbp: 'Budgeted £',
    rfvo_title:     'Realized Fin. × Budget',
    rfvo_of_budget: 'of budget',
    rfvo_balance:   'Balance',
    rfvo_no_budget: 'No budget set',
    kpi_contratado: 'Forecast',
    kpi_contratado_gbp: 'Forecast £',
    kpi_real_ops: 'Real. Ops',
    kpi_real_fin: 'Real. Fin',
    kpi_delta: 'Δ Ops vs Fin',
    kpi_status: 'Status',
    // Month names (short)
    month_jan: 'Jan', month_feb: 'Feb', month_mar: 'Mar', month_apr: 'Apr',
    month_may: 'May', month_jun: 'Jun', month_jul: 'Jul', month_aug: 'Aug',
    month_sep: 'Sep', month_oct: 'Oct', month_nov: 'Nov', month_dec: 'Dec',
    // Month names (full)
    month_january: 'January', month_february: 'February', month_march: 'March',
    month_april: 'April', month_may_full: 'May', month_june: 'June',
    month_july: 'July', month_august: 'August', month_september: 'September',
    month_october: 'October', month_november: 'November', month_december: 'December',
    // Institute
    inst_title:      'Institute',
    inst_subtitle:   'Budget control by division · Forecast and Contracted · saves on field blur',
    inst_budget:     'Institute Budget',
    inst_total_forecast: 'Total Budgeted',
    inst_total_contracted: 'Total Contracted',
    inst_s1_forecast:    'H1 Budgeted',
    inst_s2_forecast:    'H2 Budgeted',
    inst_s1_contracted:  'H1 Contracted',
    inst_s2_contracted:  'H2 Contracted',
    inst_delta:          'Delta (Forecast − Contracted)',
    inst_saving:         '💾 Saving...',
    inst_rubrica:        'Category',
    inst_total_anual:    'Annual Total',
    inst_orc_cont:       'Budgeted / Contracted',
    inst_orc:            'Budgeted',
    inst_cont:           'Contracted',
    inst_row_rt:           'Roundtable',
    inst_row_viagCliente:  'Commercial Travel (Clients)',
    inst_row_viagStaff:    'Commercial Travel (Staff)',
    inst_row_instGeral:    'Institute General',
    inst_disc_title:       'Project discounts (late launches)',
    inst_disc_subtitle:    'Prior-year projects whose costs were launched after the year close and discounted from this institute.',
    inst_disc_total:       'Total discounted',
    inst_disc_late:        'launched after year close',
    inst_disc_launches:    'launches',
    inst_launches:         'Launches',
    inst_launch_trace:     'another year',
    inst_budget_available: 'Available after launches',
    tour_start: 'How to use',
    tour_skip: 'Skip',
    tour_prev: 'Back',
    tour_next: 'Next',
    tour_done: 'Done',
    tour_inst_intro_title: 'Institute screen',
    tour_inst_intro_body: 'A quick tour of the key spots on this screen. Use Next/Back or the arrow keys; Esc closes.',
    tour_inst_div_title: 'Pick the division',
    tour_inst_div_body: 'Select the division whose institute you want to view or edit. Operations sees only its own; Finance and Admin, all.',
    tour_inst_year_title: 'Current year',
    tour_inst_year_body: 'Switch the year here. Values, budget and launches change with the selected year.',
    tour_inst_kpis_title: 'Indicators',
    tour_inst_kpis_body: 'Division summary:',
    tour_inst_kpis_b1: 'Available budget — already net of launches',
    tour_inst_kpis_b2: 'Annual forecast and contracted',
    tour_inst_kpis_b3: 'Delta = forecast − contracted + launches',
    tour_inst_kpis_b4: 'Total launches for the year',
    tour_inst_grid_title: 'Month-by-month editing',
    tour_inst_grid_body: 'Edit each month/row:',
    tour_inst_grid_b1: 'Click the field and type — it saves automatically',
    tour_inst_grid_b2: 'Press "-" for negative values',
    tour_inst_grid_c_amber: 'Amber: negative value',
    tour_inst_grid_c_red: 'Red: contracted over forecast',
    tour_inst_grid_c_green: 'Green: contracted within forecast',
    tour_inst_launch_title: 'Late launches',
    tour_inst_launch_body: 'Costs from closed-year events land here (Institute General).',
    tour_inst_launch_b1: 'Click to open the modal with the full list',
    tour_inst_launch_b2: "They reduce the current year's available budget and delta",
    tour_inst_launch_b3: 'In the reference year they show for traceability only',
    tour_inst_done_title: 'All set!',
    tour_inst_done_body: 'You can reopen this tour anytime via the "How to use" button in the menu.',
    // Somatória
    soma_subtitle:   'Projects + Institute by division · £ GBP',
    soma_budget:     'Approved Budget',
    soma_plan:       'Ops Planning',
    soma_delta:      'Delta',
    soma_extra:      'Extra Budget (50%)',
    soma_v1:         'Plan V1',
    soma_evts:       'Evts',
    soma_plan_col:   'Plan',
    soma_extra_col:  'Extra 50%',
    soma_v1_col:     'V1',
    soma_total_plan: 'Total · Planning',
    // FX Rates
    fx_title:             'Exchange Rates',
    fx_subtitle:          'Conversion rates to GBP (£) used throughout the system.',
    fx_subtitle_canedit:  'Click a rate to edit.',
    fx_base:              'System base currency',
    fx_base_card_label:   'System base currency',
    fx_updated:           'Updated on',
    fx_click_edit:        'Click to edit',
    fx_loading:           'Loading rates...',
    fx_status_title:      'Status',
    fx_status:            'Status',
    fx_active_currencies: 'Active currencies',
    fx_base_currency:     'Base currency',
    fx_last_update:       'Last update',
    fx_how_title:         'How it works',
    fx_how_it_works:      'How rates work',
    fx_how_body1:         'Each rate shows how many units of the currency equal £ 1.',
    fx_how_body2:         'Example: USD ≈ 1.36 → £ 1,000 = US$ 1,360.',
    fx_how_body3:         'Changes take effect immediately on reports, but do not alter already saved values.',
    fx_equiv_title:       'Equivalent to £ 1,000',
    fx_equivalent_panel:  'Equivalent to £ 1,000',
    fx_note:              'How rates work: all values entered in non-GBP currencies are automatically converted using these rates.',
    fx_confirm_title:     'Confirm rate change',
    fx_confirm_note_bold: 'Attention:',
    fx_confirm_note:      'this rate will be used immediately across all dashboards, reports and conversion calculations. Values already saved in the database',
    fx_modal_changing:    'You are changing the rate for',
    fx_modal_note:        'This rate will be used immediately across all dashboards, reports and conversion calculations. Values already saved in the database',
    fx_modal_note_bold:   'will not be changed',
    fx_modal_note_suffix: '— only the GBP conversion will be recalculated.',
    fx_confirm_cancel:    'Cancel',
    fx_confirm_save:      'Confirm change',
    logout_title:         'Sign out',
    logout_body:          'You will be signed out of your GRI Institute account. Do you want to continue?',
    logout_cancel:        'Cancel',
    logout_confirm:       'Sign out',
    settings_title:      'Preferences',
    settings_language:   'Language',
    users_no_division:        'No division',
    users_confirm_block_title:   'Block user',
    users_confirm_block_body:    'This user will be blocked and will no longer be able to access the system.',
    users_confirm_block_btn:     'Block',
    users_confirm_unblock_title: 'Reactivate user',
    users_confirm_unblock_body:  'This user will regain access to the system with Viewer role.',
    users_confirm_unblock_btn:   'Reactivate',
    app_title: 'Planning and Cost Control',
    theme_to_light: 'Light theme',
    theme_to_dark: 'Dark theme',
    // KPI hints
    kpi_hint_proj_budget:     'Approved budget',
    kpi_hint_inst_budget:     'Budget allocated to Institute',
    kpi_hint_inst_budget_missing: 'Not configured for this year',
    kpi_configure: 'Configure',
    dash_how_title: 'How to read this panel',
    dash_how_1: 'Budget: approved value for events or Institute.',
    dash_how_2: 'Contracted: sum of contracted cost lines, converted to GBP.',
    dash_how_3: 'Delta: Budget − Contracted. Negative = over budget.',
    dash_how_4: 'ForecastV1: adjusted projection based on semester extrapolation.',
    events_how_title: 'How Projects work',
    events_how_1: 'Each event has cost lines (accounts) and items within each line.',
    events_how_2: 'Approved Budget: reference value set by Finance.',
    events_how_3: 'Initial Contract: confirms planning has been reviewed.',
    events_how_4: 'Final Contract: post-event approval. Locks event edits.',
    inst_how_title: 'How Institute works',
    inst_how_1: 'Categories: Roundtable (internal travel), Travel w/ Client, Travel w/ Staff, General Inst.',
    inst_how_2: 'Budgeted: planned value for the month. Contracted: already committed value.',
    inst_how_3: 'S1 = Jan–Jun, S2 = Jul–Dec. Totals calculated automatically.',
    inst_how_4: 'The annual division budget is configured in Administration → Institute Budgets.',
    budgets_how_title: 'How to configure budgets',
    budgets_how_1: 'Set the annual Institute budget per division for each future year.',
    budgets_how_2: 'Past years are locked and cannot be edited.',
    budgets_how_3: 'The value here impacts KPIs across all system screens.',
    audit_how_title: 'About the Change Log',
    audit_how_1: 'Records all creations, edits and deletions made by users.',
    audit_how_2: 'Expand each row to see the field-by-field diff (before → after).',
    audit_how_3: 'Only administrators have access to this screen.',
    kpi_hint_total_orc:       'Projects + Institute',
    kpi_hint_contracted:      'Total contracted so far',
    kpi_hint_within:          '✓ Within budget',
    kpi_hint_over:            '⚠ Over budget',
    kpi_hint_inst_budget_div: 'Division approved budget',
    kpi_hint_forecast_sum:    'Annual forecast total',
    kpi_hint_contracted_sum:  'Annual contracted total',
    kpi_hint_launches_sum:    'Post-close launches',
    toggle_contract_initial:     'Initial contract closed',
    toggle_contract_final:       'Final contract approved by Ops',
    toggle_final_date_required:  'available after event date',
    toggle_final_locked:         'Event locked — irreversible approval',
    toggle_final_confirm_title:  'Confirm final approval',
    toggle_final_confirm_body:   'By confirming, the event and its items will be permanently locked for editing. This action cannot be undone. Are you sure?',
    toggle_final_confirm_btn:    'Confirm',
    toggle_final_reopen:          'Reopen',
    kpi_hint_s1:              'Jan–Jun',
    kpi_hint_s2:              'Jul–Dec',
    kpi_hint_soma_budget:     'Projects + Institute',
    kpi_hint_soma_plan:       'Ops Team — total forecast',
    kpi_hint_soma_delta:      'Over budget',
    kpi_hint_soma_extra:      'Approved: delta / 2',
    kpi_hint_soma_v1:         'Budget + Approved extra',
    // Status badges
    status_ok:   'OK',
    status_over: 'OVER',
    status_over_budget: 'OVER BUDGET',
    fx_btn_save_inline:   'Save',
    fx_saving:            'Saving...',
    fx_saved:             '✓ Saved',
    fx_unit_value:        '1 unit of the currency',
    fx_gbp_value:         'is worth in GBP (£)',
    fx_example:           'Example',
    fx_immediate:         'immediate',
    fx_no_change_saved:   'does not alter already saved values',
    // Usuários
    users_title:     'Users',
    users_role:      'Role',
    users_division:  'Division',
    users_save:      'Save',
    users_subtitle:      'Manage roles and division access',
    users_you:           'you',
    users_saved:         '✓ Saved',
    users_saving:        'Saving…',
    users_role_viewer:   'Viewer',
    users_role_viewer_desc: 'Read-only',
    users_role_ops:      'Ops Manager',
    users_role_ops_desc: 'Edit costs for their division',
    users_role_finance:  'Finance',
    users_role_finance_desc: 'Edit everything',
    users_role_admin:    'Admin',
    users_role_admin_desc: 'Full access + users',
    // Audit
    audit_title:     'Change Log',
    audit_subtitle:  'History of all edits — who did what, when',
    audit_all:       'All',
    audit_cost_lines: 'Cost Lines',
    audit_cost_items: 'Cost Items',
    audit_events:    'Events',
    audit_fx:        'Exchange Rates',
    audit_changed_fields: 'Changed fields',
    audit_no_changes: 'No value changes detected.',
    audit_prev:      '← Previous',
    audit_next:      'Next →',
    audit_records:   'records',
    audit_record:    'record',
    audit_page_of:   'page',
    audit_of:        'of',
    audit_action_create: 'Created',
    audit_action_update: 'Edited',
    audit_action_delete: 'Deleted',
    audit_table_cost_line:      'Cost Line',
    audit_table_cost_line_item: 'Cost Item',
    audit_table_institute:      'Institute',
    audit_table_event:          'Event',
    audit_table_fx_rate:        'Exchange Rate',
    audit_table_user:           'User',
    audit_table_division_budgets: 'Division Budget',
    audit_more_fields:  '+{n} more',
    audit_insert_values: 'Added values',
    audit_delete_values: 'Removed values',
    audit_filter_user:  'User',
    audit_filter_all_users: 'All users',
    audit_filter_from:  'From',
    audit_filter_to:    'To',
    // Timeline
    timeline_title:      'Project Schedule',
    timeline_subtitle:   'Click a month to see events, contracts and settlements',
    timeline_all:        'All',
    timeline_events_in:  '🎯 Events in',
    timeline_contracts:  '📋 Contracts to close this month',
    timeline_settlements:'💳 Expected settlements (+15 business days)',
    timeline_no_activity:'No activity in',
    timeline_collision:  '⚠️ COLLISION',
    timeline_status_late:'Late',
    timeline_status_this_month: 'This month',
    timeline_status_todo:'To do',
    timeline_status_expected:'Expected',
    timeline_budget:     'Budget:',
    timeline_contracted_pct: 'contr.',
    timeline_event_status_final:   '🔒 Final Contract',
    timeline_event_status_initial: '📋 Initial Contract',
    timeline_event_status_pending: '⏳ No contract',
    timeline_event_in:   'Event on',
    timeline_events_count: 'events',
    timeline_contracts_count: 'contracts',
    timeline_settlements_count: 'settlements',
    // Manage Events
    manage_title:        'Event Management',
    manage_subtitle:     'events · create, edit and delete',
    manage_new_event:    '+ New event',
    manage_search:       '🔍 Search event...',
    manage_all_divisions:'All divisions',
    manage_no_events:    'No events registered yet.',
    manage_no_filter:    'No events found with these filters.',
    manage_form_name:    'Event name',
    manage_form_name_ph: 'E.g.: GRI São Paulo Summit 2026',
    manage_form_division:'Division',
    manage_form_type:    'Type',
    manage_form_date:    'Date',
    manage_form_budget:  'Approved budget',
    manage_form_sf_id:   'Salesforce ID (optional)',
    manage_form_sf_ph:   'E.g.: a0B5e000003XXXX',
    manage_form_note:    'General note (optional)',
    manage_form_note_ph: 'Notes...',
    manage_edit_event:   '✏️ Edit Event',
    manage_edit_budget:  'Edit Budget',
    manage_new_event_title: '+ New Event',
    manage_saving:       'Saving...',
    manage_save_changes: 'Save changes',
    manage_create_event: 'Create event',
    manage_delete_title: 'Delete event?',
    manage_delete_msg:   'and all its costs will be permanently removed.',
    manage_deleting:     'Deleting...',
    manage_contracted:   'contracted',
    manage_sf_label:     'SF:',
    manage_event_count:  'event',
    manage_events_count: 'events',
    // Sync status
    sync_status_label:   'Salesforce',
    sync_status_ok:      'Up to date',
    sync_status_errors:  'Last sync with errors',
    sync_status_outdated:'Outdated',
    sync_status_waiting: 'Awaiting first sync (06:00 BRT)',
    sync_last_update:    'last update on',
    sync_at:             'at',
    sync_auto:           'Automatic · 06:00 BRT',
    sync_events_updated: 'events updated',
    sync_of_received:    'of',
    sync_received_sf:    'received from SF',
    sync_errors:         'error(s)',
    // Currency names
    currency_name_GBP: 'British Pound',
    currency_name_EUR: 'Euro',
    currency_name_USD: 'US Dollar',
    currency_name_BRL: 'Brazilian Real',
    currency_name_INR: 'Indian Rupee',
    currency_name_JPY: 'Japanese Yen',
    currency_name_CAD: 'Canadian Dollar',
    currency_name_AUD: 'Australian Dollar',
    currency_name_CHF: 'Swiss Franc',
    currency_name_CNY: 'Chinese Yuan',
    currency_GBP:    'British Pound',
    currency_EUR:    'Euro',
    currency_USD:    'US Dollar',
    currency_BRL:    'Brazilian Real',
    currency_INR:    'Indian Rupee',
    currency_AED:    'UAE Dirham',
    currency_JPY:    'Japanese Yen',
    currency_CAD:    'Canadian Dollar',
    currency_AUD:    'Australian Dollar',
    currency_CHF:    'Swiss Franc',
    currency_CNY:    'Chinese Yuan',
    // BudgetsPage
    budgets_title:              'Institute Budget by Year',
    budgets_subtitle:           'Institute budget by division · Values in £ GBP · Past years automatically locked',
    budgets_division:           'Division',
    budgets_confirm_title:      'Confirm budget change',
    budgets_current:            'Current:',
    budgets_new:                'New:',
    budgets_confirming:         'Saving...',
    budgets_confirm_btn:        'Confirm',
    // FX modal extras
    fx_currency_in_use:         'Currency in use',
    fx_currency_in_use_msg:     'is being used by',
    fx_currency_in_use_events:  'event(s)',
    fx_delete_currency:         'Delete currency',
    fx_delete_confirm_msg:      'and all its costs will be permanently removed. This action cannot be undone.',
    fx_deleting:                'Deleting...',
    fx_new_currency:            'New Currency',
    fx_new_currency_btn:        '+ New Currency',
    fx_cancel_form:             '✕ Cancel',
    // UsersPage extras
    users_access_global:        'Global access',
    users_admin_global:         'Admin has global access to all divisions.',
    users_email_label:          'Email *',
    users_name_label:           'Name (optional)',
    users_role_label:           'Role',
    users_divisions_label:      'Divisions *',
    users_adding:               'Adding...',
    users_add_btn:              'Add User',
    users_block_btn:            'Block',
    users_unblock_btn:          'Reactivate',
    users_remove_btn:           'Remove',
    users_remove_confirm:       'Remove this user from the allowlist?',
  },
} as const;

export type TranslationKey = keyof typeof translations.pt;

// Helper function to get month short name
export const getMonthShort = (month: number, lang: Lang): string => {
  const keys: TranslationKey[] = ['month_jan', 'month_feb', 'month_mar', 'month_apr', 'month_may', 'month_jun', 'month_jul', 'month_aug', 'month_sep', 'month_oct', 'month_nov', 'month_dec'];
  return translations[lang][keys[month - 1]] || '';
};

// Helper function to get month full name
export const getMonthFull = (month: number, lang: Lang): string => {
  const keys: TranslationKey[] = ['month_january', 'month_february', 'month_march', 'month_april', 'month_may_full', 'month_june', 'month_july', 'month_august', 'month_september', 'month_october', 'month_november', 'month_december'];
  return translations[lang][keys[month - 1]] || '';
};

// Helper function to get locale for date formatting
export const getLocale = (lang: Lang): string => lang === 'en' ? 'en-GB' : 'pt-BR';

// ─── Contexto ─────────────────────────────────────────────────────────────────
interface I18nContext {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: (key: TranslationKey) => string;
}

const Ctx = createContext<I18nContext>({
  lang: 'pt',
  setLang: () => {},
  t: (key) => key,
});

export function I18nProvider({ children }: { children: ReactNode }) {
  const raw = localStorage.getItem('oraculo_lang');
  const stored: Lang = raw === 'pt' || raw === 'en' ? raw : 'pt';
  const [lang, setLangState] = useState<Lang>(stored);

  // lang do <html> acompanha o idioma do app, senão o Chrome oferece tradução indevida
  useEffect(() => { document.documentElement.lang = lang === 'en' ? 'en' : 'pt-BR'; }, [lang]);

  const setLang = (l: Lang) => {
    localStorage.setItem('oraculo_lang', l);
    setLangState(l);
  };

  const t = (key: TranslationKey): string => {
    const val = translations[lang][key];
    return typeof val === 'string' ? val : key;
  };

  return <Ctx.Provider value={{ lang, setLang, t }}>{children}</Ctx.Provider>;
}

export const useI18n = () => useContext(Ctx);
